import type { FieldValues } from 'react-hook-form';
import { useController } from 'react-hook-form';

import type { ToggleProps } from '~/components/Toggle';
import { Toggle } from '~/components/Toggle';

import type { FormFieldProps } from '../../FormField';
import { FormField } from '../../FormField';

type FormFieldToggleProps<TFormFields extends FieldValues> = Omit<
  FormFieldProps<TFormFields>,
  'children'
> &
  Omit<ToggleProps, 'name' | 'className' | 'variant'>;

export function FormFieldToggle<TFormFields extends FieldValues>({
  name,
  label,
  className,
  disabled,
  readOnly,
  ...toggleProps
}: FormFieldToggleProps<TFormFields>) {
  const { field } = useController({ name, disabled });

  return (
    <FormField
      name={name}
      label={label}
      className={className}
      disabled={disabled}
      readOnly={readOnly}
    >
      <Toggle
        {...field}
        pressed={field.value}
        onPressedChange={field.onChange}
        aria-labelledby={name}
        variant="formField"
        {...toggleProps}
        disabled={disabled || readOnly}
      />
    </FormField>
  );
}

FormFieldToggle.displayName = 'FormFieldToggle';
